import LocationSummary from "../components/app/Location/LocationSummary";

function LocationInformationPage(){
  return(<LocationSummary></LocationSummary>);
}

export default LocationInformationPage